import {service} from "infrastructure/index";
import {isSuccessResponse} from "presentation/common";

export async function loadUnSignedDocuments(userInfo, dispatch) {
  try {
    const response = await service.getUnSignedDocs(userInfo);

    if (isSuccessResponse(response)) {
      dispatch.unSignedDocs.updateUnSignedDocuments(response.data || [])
    }
  } catch (e) {

  }
}
